import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

const LoaderSm = ({ height = '300px' }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={height}
    >
      <CircularProgress />
    </Box>
  )
}

export default LoaderSm
